import { render } from "./policies.vue?vue&type=template&id=54ae3a56&scoped=true"
import script from "./policies.vue?vue&type=script&lang=js"
export * from "./policies.vue?vue&type=script&lang=js"

import "./policies.vue?vue&type=style&index=0&id=54ae3a56&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ae3a56"]])

export default __exports__